angular.module('zc.core')
  .factory('funnelChartV2Config', funnelChartV2Config);

funnelChartV2Config.$inject = ['baseChartV2Config'];
function funnelChartV2Config(baseChartV2Config) {
  return angular.merge({
    options: {
      chart: {
        type: 'funnel',
        width: 300,
        height: 120,
      },
      plotOptions: {
        series: {
          dataLabels: {
            distance: 0,
            formatter: function() {
              // NOTE: Squaring values which is stored as rooted
              const total = Math.round(this.series.yData[0] ** 2);
              const y = Math.round(this.y ** 2);
              const percent = Math.round(y / total * 100);
              return `${this.key} (${percent}%)`;
            },
          },
          enableMouseTracking: false,
          width: 180,
          neckWidth: '0%',
          neckHeight: '0%',
        }
      },
    },
  }, baseChartV2Config);
}



// WEBPACK FOOTER //
// ../app_shared/src/shared_modules/core/services/funnel_chart_v2_config.service.js